import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  background: ${({theme}) => theme.colors.alert};
  padding: ${RFValue(12)}px ${RFValue(16)}px;
  border-radius: ${RFValue(12)}px;
  flex-direction: row;

  align-items: center;
  margin-bottom: ${RFValue(12)}px;
`;

export const ListNumber = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  margin-right: ${RFValue(16)}px;

  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ListText = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  width: 90%;
  font-family: ${({theme}) => theme.fonts.regular};
`;
